import React from 'react';
import { Card } from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';
import Select from 'react-select';
import { useSelector } from 'react-redux';
import { set, cloneDeep, get } from 'lodash';
import { useTranslation } from 'react-i18next';
import { customStyles, roundingOff, targetControl, allowOnlyNumber, currency_symbols } from '../../../../../Components/helper';
import { usePurchaseOrderState } from '../../PurchaseOrderContext/index';
import { colourPath } from '../../fieldPath';
import useSinglePackedUnits from '../../Hooks/useSinglePackedUnits';
import useGrandTotal from '../../Hooks/useGrandTotal';
import CustomDatePicker from '../../../../../Components/Utility/DatePicker/DatePicker';

export const SinglePackedUnits = ({ data, parentIndex }) => {
  const { t } = useTranslation('common');
  const {
    purchaseOrderData: { sizesData, legLengths },
    BOMConfigDetails: { productDetails },
  } = useSelector((reduxState) => reduxState);
  const { calculateSinglePackedUnits } = useSinglePackedUnits();
  const { calculateGrandTotal } = useGrandTotal();
  const {
    purchaseOrderState: { selectedCurrency },
    setPurchaseOrderState,
    purchaseOrderState,
    disableConditions,
    fromPreview,
    isPublicPoPage,
    poAddEditAccess,
    poDeleteAccess,
    lengthEnabled,
  } = usePurchaseOrderState();
  const AddPath = 'COMMON_LABEL.ADD';
  const deletePath = 'COMMON_LABEL.DELETE';

  const onChange = async (value, keyPath, i) => {
    const copyState = purchaseOrderState;
    set(copyState, keyPath, value);
    const singlePackedRowsDataPath = colourPath(parentIndex, i).SINGLE_PACKED_UNIT.COMMON_PATH;
    const singularPackedUnit = get(copyState, singlePackedRowsDataPath);
    const obj = cloneDeep(await calculateSinglePackedUnits(singularPackedUnit));
    set(copyState, singlePackedRowsDataPath, obj);
    const obj2 = cloneDeep(await calculateGrandTotal(copyState));
    setPurchaseOrderState((prevState) => ({ ...prevState, ...obj2 }));
  };

  const addRow = async (element, colIndex) => {
    const copyState = cloneDeep(data[colIndex]);
    copyState.singularPackedRows.push(element);
    const obj = cloneDeep(await calculateSinglePackedUnits(copyState));
    const CopyState = { ...purchaseOrderState };
    set(CopyState, `templateJsonSchema[${parentIndex}].sigularPackedUnits[${colIndex}]`, obj);
    const obj2 = cloneDeep(await calculateGrandTotal(CopyState));
    setPurchaseOrderState((prevState) => ({ ...prevState, ...obj2 }));
  };

  const deleteRow = async (i, colIndex) => {
    const copyState = cloneDeep(data[colIndex]);
    copyState.singularPackedRows.splice(i, 1);
    const obj = cloneDeep(await calculateSinglePackedUnits(copyState));
    const CopyState = { ...purchaseOrderState };
    set(CopyState, `templateJsonSchema[${parentIndex}].sigularPackedUnits[${colIndex}]`, obj);
    const obj2 = cloneDeep(await calculateGrandTotal(CopyState));
    setPurchaseOrderState((prevState) => ({ ...prevState, ...obj2 }));
  };

  const addNewCard = async (element) => {
    const copyState = cloneDeep(data);
    const tempEle = element;
    tempEle.shipmentDate = null;
    tempEle.handOverDate = null;
    copyState.push(tempEle);
    const obj = cloneDeep(await calculateSinglePackedUnits(copyState));
    const CopyState = { ...purchaseOrderState };
    set(CopyState, `templateJsonSchema[${parentIndex}].sigularPackedUnits`, obj);
    const obj2 = cloneDeep(await calculateGrandTotal(CopyState));
    setPurchaseOrderState((prevState) => ({ ...prevState, ...obj2 }));
  };

  const deleteExistingCard = async (i) => {
    const copyState = cloneDeep(data);
    copyState.splice(i, 1);
    const obj = cloneDeep(await calculateSinglePackedUnits(copyState));
    const CopyState = { ...purchaseOrderState };
    set(CopyState, `templateJsonSchema[${parentIndex}].sigularPackedUnits`, obj);
    const obj2 = cloneDeep(await calculateGrandTotal(CopyState));
    setPurchaseOrderState((prevState) => ({ ...prevState, ...obj2 }));
  };

  const changeHandOverDate = (e, i) => {
    const copyState = cloneDeep(data);
    const tempEle = data[i];
    tempEle.handOverDate = e;
    const CopyState = { ...purchaseOrderState };
    set(CopyState, `templateJsonSchema[${parentIndex}].sigularPackedUnits[${i}]`, tempEle);
    setPurchaseOrderState((prevState) => ({ ...prevState, ...copyState }));
  };

  const changeShipmentDate = (e, i) => {
    const copyState = cloneDeep(data);
    const tempEle = data[i];
    tempEle.shipmentDate = e;
    const CopyState = { ...purchaseOrderState };
    set(CopyState, `templateJsonSchema[${parentIndex}].sigularPackedUnits[${i}]`, tempEle);
    setPurchaseOrderState((prevState) => ({ ...prevState, ...copyState }));
  };

  const disableFn = () => {
    return disableConditions() || fromPreview || isPublicPoPage;
  };

  const hasDate = (element) => {
    return element ? new Date(element) : null;
  };

  return data?.map((ele, i) => {
    return (
      <Card key={i} className="card-margin-bottom rounded-0">
        <Card.Header className="bgcolor-dark rounded-0">
          <div className="d-flex flex-wrap align-items-center p-2">
            <strong>{t('FILTER.SINGLE_PACKED_UNITS')}</strong>
            <div className="date px-3 ml-md-auto">
              <div className="input-button-container bg-white">
                <CustomDatePicker
                  dateFormat="dd/MM/yyyy"
                  name={t('FILTER.HANDOVER_SINGLEPACK_UNITS')}
                  popperPlace="top-end"
                  keyProp={`handOverDate_${parentIndex}_${i}_Singlepack`}
                  placeholder={t('FILTER.HANDOVER_DATE')}
                  disable
                  onChange={(e) => {
                    changeHandOverDate(e, i);
                  }}
                  valueProp={hasDate(data[i]?.handOverDate)}
                />
              </div>
            </div>
            <div className="date justify-content-end px-1">
              <div className="input-button-container bg-white">
                <CustomDatePicker
                  dateFormat="dd/MM/yyyy"
                  keyProp={`ShipmentDate_${parentIndex}_${i}_Singlepack`}
                  name={t('FILTER.SHIPMENT_DATE_SINGLEPACK')}
                  popperPlace="top-end"
                  placeholder={t('FILTER.SHIPMENT_DATE')}
                  disable
                  onChange={(e) => changeShipmentDate(e, i)}
                  valueProp={hasDate(data[i]?.shipmentDate)}
                />
              </div>
            </div>
          </div>
        </Card.Header>
        {!fromPreview && !isPublicPoPage && (
          <div className="d-flex pt-2 justify-content-end">
            {data?.length === i + 1 && poAddEditAccess && (
              <button className="btn btn-outline" type="button" onClick={() => addNewCard(ele)} disabled name={t(AddPath)} aria-label={t(AddPath)}>
                <i className="icon-add" />
              </button>
            )}
            {data?.length !== 1 && poDeleteAccess && (
              <button
                className="btn btn-outline px-1 "
                type="button"
                onClick={() => deleteExistingCard(i)}
                disabled
                name={t(deletePath)}
                aria-label={t(deletePath)}
              >
                <i className="icon-delete" />
              </button>
            )}
          </div>
        )}
        <Card.Body>
          <div className="table-responsive">
            <table className="table custom-table font-13 mb-3">
              <thead>
                <tr>
                  <th>{t('ORDER_PREVIEW_DETAILS.SIGE')}</th>
                  {lengthEnabled && <th>{t('PROGRESS_INDICATOR.LENGTH')}</th>}
                  <th>{t('COSTING_TO_DO_LIST.QUANTITY')}</th>
                  <th>{t('FILTER.PRICE_PER_UNIT_RATIO')}</th>
                  <th>{t('FILTER.DISCOUNT_PER_UNIT')}</th>
                  <th>{t('FILTER.PRICE_PER_UNIT_DISCOUNT')}</th>
                  {!fromPreview && !isPublicPoPage && <th className="w-150px">{t('COSTING_TO_DO_LIST.ACTION')}</th>}
                </tr>
              </thead>
              <tbody>
                {ele?.singularPackedRows?.map((element, index) => {
                  return (
                    (!fromPreview || !isPublicPoPage || (fromPreview && isPublicPoPage && element?.size)) && (
                      <tr key={index}>
                        <td>
                          <div className="custom-react-select">
                            <Select
                              name="size"
                              options={sizesData}
                              getOptionLabel={(option) => `${option?.name}`}
                              getOptionValue={(option) => `${option?.name}`}
                              value={(element?.size || typeof element?.size === 'number' ? { name: element?.size } : null) || ''}
                              styles={customStyles}
                              isDisabled
                              maxMenuHeight={129}
                              menuPlacement="bottom"
                              menuPosition="fixed"
                              menuShouldBlockScroll
                              menuShouldScrollIntoView
                              onChange={(event) => {
                                onChange(event?.name, colourPath(parentIndex, i, index)?.SINGLE_PACKED_UNIT?.SIZE_PATH, i);
                              }}
                              placeholder={t('FILTER.SELECT_SIZE')}
                            />
                          </div>
                        </td>
                        {lengthEnabled && (
                          <td>
                            <Select
                              name="length"
                              options={legLengths}
                              getOptionLabel={(option) => `${option?.name}`}
                              getOptionValue={(option) => `${option?.name}`}
                              value={(element?.length ? element?.length : null) || ''}
                              styles={customStyles}
                              isDisabled
                              maxMenuHeight={129}
                              menuPlacement="bottom"
                              menuPosition="fixed"
                              onChange={(event) => {
                                onChange({ name: event?.name }, colourPath(parentIndex, i, index)?.SINGLE_PACKED_UNIT?.LENGTH_PATH, i);
                              }}
                              placeholder={t('FILTER.SELECT_LENGTH')}
                            />
                          </td>
                        )}
                        <td>
                          <input
                            type="text"
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(e) => allowOnlyNumber(e)}
                            name="Quantity"
                            placeholder={t('COSTING_TO_DO_LIST.QUANTITY')}
                            className="form-control text-bordered"
                            value={element?.quantity || ''}
                            disabled
                            onChange={(e) => {
                              targetControl(e);
                              onChange(e.target.value, colourPath(parentIndex, i, index)?.SINGLE_PACKED_UNIT?.QUANTITY_PATH, i);
                            }}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(e) => allowOnlyNumber(e)}
                            name="Price Per Unit (Before Discount)"
                            placeholder={t('FILTER.PRICE_PER_UNIT_RATIO')}
                            className="form-control text-bordered"
                            value={element?.beforeDiscPrice || ''}
                            disabled
                            onChange={(e) => {
                              targetControl(e);
                              onChange(e.target.value, colourPath(parentIndex, i, index)?.SINGLE_PACKED_UNIT?.BEFORE_DISCOUNT_PATH, i);
                            }}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(e) => allowOnlyNumber(e)}
                            name="Discount"
                            placeholder={t('PROGRESS_INDICATOR.DISCOUNT')}
                            className="form-control text-bordered"
                            value={element?.discount || ''}
                            disabled
                            onChange={(e) => {
                              targetControl(e);
                              onChange(e.target.value, colourPath(parentIndex, i, index)?.SINGLE_PACKED_UNIT?.DISCOUNT_PATH, i);
                            }}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="Price Per Unit (After Discount)"
                            placeholder={t('FILTER.PRICE_PER_UNIT_DISCOUNTS')}
                            className="form-control text-bordered"
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(e) => allowOnlyNumber(e)}
                            value={(element?.afterDiscPrice ? roundingOff(element?.afterDiscPrice, 2) : null) || ''}
                            readOnly
                            disabled
                            onChange={(e) => onChange(e.target.value, colourPath(parentIndex, i, index)?.SINGLE_PACKED_UNIT?.AFTER_DISCOUNT_PATH, i)}
                          />
                        </td>
                        {!fromPreview && !isPublicPoPage && (
                          <td>
                            <div className="d-flex">
                              {poAddEditAccess && (
                                <button
                                  name={t(AddPath)}
                                  aria-label={t(AddPath)}
                                  className="btn btn-outline"
                                  type="button"
                                  disabled
                                  onClick={() => addRow(element, i)}
                                >
                                  <i className="icon-add" />
                                </button>
                              )}
                              {ele?.singularPackedRows?.length !== 1 && poDeleteAccess && (
                                <button
                                  className="btn btn-outline px-1"
                                  type="button"
                                  disabled
                                  onClick={() => deleteRow(index, i)}
                                  name={t(deletePath)}
                                  aria-label={t(deletePath)}
                                >
                                  <i className="icon-delete" />
                                </button>
                              )}
                            </div>
                          </td>
                        )}
                      </tr>
                    )
                  );
                })}
                <tr key={i}>
                  <td colSpan={7}>
                    <strong className="d-flex align-item-center justify-content-center">{t('ORDER_PREVIEW_DETAILS.TOTAL')}</strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    {((fromPreview && isPublicPoPage && ele?.totalSize) || !fromPreview || !isPublicPoPage) && (
                      <strong>
                        {((fromPreview && isPublicPoPage && ele?.totalLength) || !fromPreview || !isPublicPoPage) &&
                          (ele?.totalSize ? roundingOff(ele?.totalSize, 2) : null)}
                      </strong>
                    )}
                  </td>
                  <td>
                    <strong>
                      {((fromPreview && isPublicPoPage && ele?.totalLength) || !fromPreview || !isPublicPoPage) &&
                        (ele?.totalLength ? new Intl.NumberFormat().format(roundingOff(ele?.totalLength, 2)) : null)}
                    </strong>
                  </td>
                  <td>
                    <strong>
                      {((fromPreview && isPublicPoPage && ele?.totalQuantity) || !fromPreview || !isPublicPoPage) && ele?.totalQuantity
                        ? new Intl.NumberFormat().format(roundingOff(ele?.totalQuantity, 2))
                        : null}
                    </strong>
                  </td>
                  <td>
                    <strong>
                      {((fromPreview && isPublicPoPage && ele?.totalPriceBeforeDisc) || !fromPreview || !isPublicPoPage) &&
                        (ele?.totalPriceBeforeDisc ? (
                          <>
                            <span className="px-1">
                              {currency_symbols[selectedCurrency?.label] ? currency_symbols[selectedCurrency?.label] : selectedCurrency?.label}
                            </span>
                            {new Intl.NumberFormat().format(roundingOff(ele?.totalPriceBeforeDisc, 2))}
                          </>
                        ) : null)}
                    </strong>
                  </td>
                  <td>
                    <strong>
                      {((fromPreview && isPublicPoPage && ele?.totalDiscountPerUnit) || !fromPreview || !isPublicPoPage) &&
                        (ele?.totalDiscountPerUnit ? new Intl.NumberFormat().format(roundingOff(ele?.totalDiscountPerUnit, 2)) : null)}
                    </strong>
                  </td>
                  <td colSpan={2}>
                    {((fromPreview && isPublicPoPage && ele?.totalPriceAfterDisc) || !fromPreview || !isPublicPoPage) &&
                      (ele?.totalPriceAfterDisc ? (
                        <strong>
                          <span className="px-1">
                            {currency_symbols[selectedCurrency?.label] ? currency_symbols[selectedCurrency?.label] : selectedCurrency?.label}
                          </span>
                          {new Intl.NumberFormat().format(roundingOff(ele?.totalPriceAfterDisc, 2))}
                        </strong>
                      ) : null)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Card.Body>
      </Card>
    );
  });
};

export default SinglePackedUnits;
